
import React, { useEffect, useRef, useState } from "react";

import { Progress } from 'react-sweet-progress';

// import { PrimeReactProvider, PrimeReactContext } from 'primereact/api';
        
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


import { InputText } from 'primereact/inputtext';





import { ActionButton, BaseButton, Button, Icon, IconButton, Link, Panel, PanelType, TextField } from "office-ui-fabric-react";
import { apiPost } from "../../../helpers-sales";
import { Loading } from "../../Shared";

import { appPackagesDefault, getItemFieldValue, WsDeliverApp, WsDeliverAppPackage } from "../apps-core";
import { getConfigValue, setConfigValue } from "../../Sales/Solution/helpers";







//theme
import "primereact/resources/themes/saga-orange/theme.css";     
    
//core
import "primereact/resources/primereact.min.css"; 

import 'react-sweet-progress/lib/style.css';

import 'primeicons/primeicons.css';


// // React Grid Logic



import './AppsPackages.scss';




// // Theme
// import type { ColDef } from "ag-grid-community";


// import { ModuleRegistry } from "ag-grid-community";


// // Core CSS
// import { AgGridReact } from "ag-grid-react";







// // ModuleRegistry.registerModules([AllCommunityModule]);





// // Row Data Interface
// interface IRow {
//   make: string;
//   model: string;
//   price: number;
//   electric: boolean;
// }






// // Create new GridExample component
// const WsAppsPackages = () => {
//   // Row Data: The data to be displayed.
//   const [rowData, setRowData] = useState<IRow[]>([
//     { make: "Tesla", model: "Model Y", price: 64950, electric: true },
//     { make: "Ford", model: "F-Series", price: 33850, electric: false },
//     { make: "Toyota", model: "Corolla", price: 29600, electric: false },
//   ]);

//   // Column Definitions: Defines & controls grid columns.
//   const [colDefs, setColDefs] = useState<ColDef<IRow>[]>([
//     { field: "make" },
//     { field: "model" },
//     { field: "price" },
//     { field: "electric" },
//   ]);

//   // Container: Defines the grid's theme & dimensions.
//   return (
//     <div style={{ width: "100%", height: "100%" }}>
//       <AgGridReact rowData={rowData} columnDefs={colDefs} />
//     </div>
//   );
// };









const WsAppsPackages = (props: {
  apps: WsDeliverApp[],
  loadApps: () => Promise<void>,
  panel: WsDeliverApp | null,
  setPanel: React.Dispatch<React.SetStateAction<WsDeliverApp | null>>
}) => {

  // const [ appPackages, setAppPackages ] = useState<WsDeliverAppPackage[] | null>(null);

  // const editingRows = useRef({});



  // useEffect(() => {

  //   const loadData = async () => {

  //     const result = await getConfigValue('deliver-apps-list');

  //     if (result) {
  //       setAppPackages(result);
  //     } else {
  //       const config = await setConfigValue('deliver-apps-list', [ ...appPackagesDefault ]);
  //       if (config) {
  //         console.log('new config created!');
  //         console.log(config);
  //       }
  //     }
  //   };

  //   loadData();

  // }, []);


  const apps = props.apps.filter((app) => app.fields['stage'] === 3);


  if (apps) {

    return (
      <>

        {/* <div style={{ textAlign: 'left', marginBottom: '15px' }}>
          <ActionButton
            className="ws-deliver-apps-add"
            iconProps={{ iconName: 'Add' }}
            onClick={() => {
              const next = [ { "name": "", "vendorName": "","applicationName": "", "applicationVersion": "", "silentInstallCommand": "", "silentUninstallCommand": "", "detectionMethod": "", "mediaFolderLocation": "" }, ...appPackages ];

              setAppPackages(next);
            }}
            style={{

            }}
          >
            Add Package
          </ActionButton>
        </div> */}

        <DataTable
          value={apps}
          tableStyle={{ minWidth: '50rem' }}
          editMode="row"
          // onRowEditSave={onRowEditSave}
          // onRowEditCancel={onRowEditCancel}
        >

          <Column field="fields.name"                header="Package"          style={{                }}
            // editor={(props: any) => <TextEditor {...props} />}
            // <Link></Link>
            body={(app: WsDeliverApp) => {
              return (
                <Link onClick={() => {
                  props.setPanel(app);
                }}>{app.fields.name || 'App'}</Link>
              );
            }}
          ></Column>

          <Column field="fields.applicationName"     header="Application"      style={{ width: '400px' }}
            // editor={(props: any) => <TextEditor {...props} />}
          ></Column>

          <Column field="fields.applicationVersion"  header="Version"          style={{ width: '250px' }}
            // editor={(props: any) => <TextEditor {...props} />}
          ></Column>

          {/* <Column field="vendorName"          header="Vendor"           style={{ width: '200px' }} editor={(props: any) => <TextEditor {...props} />} ></Column> */}

          {/* <Column field="detectionMethod"     header="Detection"        style={{ width: '110px' }} editor={(props: any) => <TextEditor {...props} />} ></Column> */}

          <Column
            className="ws-deliver-apps-status-column"
            header="Status"
            style={{ width: '210px' }}
            body={(app: WsDeliverApp) => {

              if (app.fields.status === 'RUNNING') {

                return (
                  <>
                    {/* <Icon
                      className="ws-deliver-app-running"
                      iconName={'Running'}
                    /> */}
                    <Progress status="active" percent={30}  />
                  </>
                );

              } else {
                return (
                  <>
                  <WsAppDeployment
                    row={app}
                    loadApps={props.loadApps}
                    // setPanel={setPanel}
                    // setAppPackages={setAppPackages}
                  />
                  </>
                );
              }
            }}
          />

          {/* <Column
            header=""
            style={{ width: '200px' }}
            body={(app: WsDeliverApp) => {
              return (
                <>
                  <ActionButton
                    iconProps={{ iconName: 'Settings' }}
                    onClick={(event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {
                      props.setPanel(app);
                    }}
                  >Details</ActionButton>
                </>
              );
            }}
          /> */}

          {/* <Column field="mediaFolderLocation" header="Media Location"                              editor={(props: any) => <TextEditor {...props} />} ></Column> */}

          {/* <Column rowEditor header="Actions" headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}></Column> */}

        </DataTable>
      </>
    );

  } else {
    return (
      <>
      <Loading/>
      </>
    );
  }
};

















type WsAppDeploymentProps = {
  row: WsDeliverApp;
  loadApps: () => Promise<void>;
  // setAppPackages: React.Dispatch<React.SetStateAction<WsDeliverAppPackage[] | null>>;
};

const WsAppDeployment = (props: WsAppDeploymentProps) => {

  const [ isLoading, setIsLoading ] = useState<boolean>(false);

  if (isLoading) {
    return (
      <>
        <Loading />
      </>
    );
  } else {

    return (
      <>
        <ActionButton
          label="Staging in Intune"
          iconProps={{ iconName: 'Play' }}
          onClick={async (event: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement | HTMLDivElement | BaseButton | Button | HTMLSpanElement, MouseEvent>) => {

            setIsLoading(true);

            const app = { ...props.row };

            app.fields.status = 'RUNNING';

            const result = await apiPost(`/deliver/deploy/${app.id}`, app);

            if (result) {
              console.log(result);
              props.loadApps();
            }

            setIsLoading(false);

          }}
        >Staging in Intune</ActionButton>
      </>
    )
  }
};















export {
  WsAppsPackages
};








// const TextEditor = (props: any) => {

//   const [ value, setValue ] = useState<string>(props.rowData[props.field]);

//   return (
//     <InputText
//       style={{ width: '100%'}}
//       type="text"
//       value={value}
//       onChange={(e: React.ChangeEvent<HTMLInputElement>) => {

//         setValue(e.target.value);

//         const rowData = { ...props.rowData };

//         rowData[props.field] = e.target.value;

//         editingRows.current[props.rowIndex] = rowData;

//       }} 
//     />
//   );
// };



// const onRowEditSave = (e: {
//   originalEvent: Event;
//   data: any;
//   index: number;
// }) => {

//   console.log(e.data);

//   console.log(editingRows);

//   if (editingRows.current[e.index]) {

//     const next = [ ...appPackages ];

//     next[e.index] = editingRows.current[e.index];

//     delete editingRows.current[e.index];

//     setAppPackages(next);

//   }

// };



// const onRowEditCancel = (e: {
//   originalEvent: Event;
//   data: any;
//   index: number;
// }) => {

//   if (editingRows.current[e.index]) {

//     delete editingRows.current[e.index];

//   }

// };